import { getReq } from "./instance";

export const getNDC = async (nDCId: string, params = {}) => {
  return getReq(`/NDC/${nDCId}`, params);
};
